import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
  { path: '/home',   icon: 'fa-house',         label: 'Home'    },
  { path: '/chat',   icon: 'fa-comment-dots',   label: 'VIVI'    },
  { external: 'https://www.intiviv.com', icon: 'fa-bag-shopping', label: 'Store' },
  { path: '/learn',  icon: 'fa-book-open',      label: 'Learn'   },
  { path: '/consult',icon: 'fa-calendar-check', label: 'Consult' },
  { path: '/you',    icon: 'fa-circle-user',    label: 'You'     },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav">
      {tabs.map(t => {
        const isActive = t.path && pathname.startsWith(t.path);
        const onTap = () => {
          if (t.external) window.open(t.external, '_blank', 'noopener,noreferrer');
          else navigate(t.path);
        };
        return (
          <button
            key={t.label}
            className={`nav-tab${isActive ? ' active' : ''}`}
            onClick={onTap}
            data-testid={`nav-${t.label.toLowerCase()}`}
          >
            <i className={`fa-solid ${t.icon}`} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
